<template>
  <p class="mb-0">
    {{ title }}: <b v-if="value">{{ value }}</b>
    <v-icon
      v-else
      color="red"
      size="16"
    >
      error
    </v-icon>
  </p>
</template>

<script>
export default {
  name: 'DIASParticipantDetail',
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: false,
      default: null,
    },
  },
};
</script>
